module.exports = __webpack_public_path__ + "img/load-bg.09b0c8cf.jpg";